import { Routes } from "@/app/routes.ts";
import { useGetCurrentUserSuspenseQuery } from "@workleap-ai/shared";
import { useEffect } from "react";
import { matchPath, useLocation } from "react-router";
import { useIntercom as useReactIntercom } from "react-use-intercom";

export const useIntercom = () => {
    const { data: { memberId, email, intercomUserHash } } = useGetCurrentUserSuspenseQuery();
    const { boot, update } = useReactIntercom();
    const location = useLocation();

    useEffect(() => {
        boot({
            userId: memberId,
            email: email,
            userHash: intercomUserHash,
            verticalPadding: 80
        });
    }, [boot, memberId, email, intercomUserHash]);

    useEffect(() => {
        if (matchPath(Routes.Conversation(":conversationId"), location.pathname)) {
            update({ hideDefaultLauncher: true });
        } else {
            update({ hideDefaultLauncher: false });
        }
    }, [update, location.pathname]);
};
